import { render } from "./DsMetadata.vue?vue&type=template&id=af46d35c&scoped=true&ts=true"
import script from "./DsMetadata.vue?vue&type=script&lang=ts"
export * from "./DsMetadata.vue?vue&type=script&lang=ts"

import "./DsMetadata.vue?vue&type=style&index=0&id=af46d35c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af46d35c"]])

export default __exports__